import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSelector } from '../../../table/state/selector'
import { STORE_TABLE } from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const tableSelectorStore = createTableSelector(selectOwnState, STORE_TABLE)



// WEBPACK FOOTER //
// ./src/modules/store/state/search/selector.js